(function () {
    "use strict";
    angular.module("app").component("habilIvmJustificationView", {
        templateUrl: "@/ivm/justification/justification-view.template.html",
        bindings: {
            request: "=",
        },
        controller: IvmJustificationViewController
    });

    IvmJustificationViewController.$inject = ["$rootScope", "enumService"];
    function IvmJustificationViewController($rootScope, enumService) {
        const $controller = Object.assign(this, {
            SetRowStyle
        });

        const ivmStatusCodes = enumService.IvmStatusCodes;

        $controller.$onInit = initialize;

        function initialize() {
            $controller.codeVMTypes = $rootScope.codeVMTypes;
            $controller.codeIVMLevels = $rootScope.codeIVMLevels;

            $controller.Justifications = $controller.request.RequestIVMTypes;
        }

        function SetRowStyle(form, range) {
            if (form.$valid && range.Unavailable) return "bg-warning";
            if (!form.$valid) return "bg-danger";

            const status = Number.parseInt($controller.request.Status);

            switch (status) {
                case (ivmStatusCodes.RetourIVMByNVO):
                    if (range.Remarks.some(remark => remark.Section === "191")) return "bg-danger";
                    if (range.Remarks.some(remark => remark.Section === "192")) return "bg-success";
                    break;
            }
        }
    }
})();